const getTitlePrefix = (section, { isInvoicingEnabled, isOnrampEnabled, isOfframpEnabled }) => {
  const letters = ['A', 'B', 'C', 'D', 'E', 'F'];

  const sections = ['order', 'invoice', 'offramp', 'refund', 'fiatBill'];

  if (!isInvoicingEnabled) {
    sections.splice(sections.indexOf('invoice'), 1);
  }

  if (!isOfframpEnabled) {
    sections.splice(sections.indexOf('offramp'), 1);
  }

  if (!isOnrampEnabled) {
    sections.splice(sections.indexOf('fiatBill'), 1);
  }

  return letters[sections.indexOf(section)];
};

export { getTitlePrefix };
